export const ConsultationStatus = Object.freeze({
  1: "Completed",
  2: "Active",
  3: "Paused",
});
